export default __webpack_public_path__ + "static/media/sc2.f3b6839e.jpg";